import { render, staticRenderFns } from "./dingdWxlist.vue?vue&type=template&id=988d1740&scoped=true"
import script from "./dingdWxlist.vue?vue&type=script&lang=js"
export * from "./dingdWxlist.vue?vue&type=script&lang=js"
import style0 from "./dingdWxlist.vue?vue&type=style&index=0&id=988d1740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988d1740",
  null
  
)

export default component.exports